import { useState } from "react"

import aula from "../../../../services/v2/aula.service"
import { abrirAulaEnPestana, mensajeDeAula } from "../../../../utils/abrirAula"
import { CAMPUS_ONLINE_ID } from "../../../../constants"
import { ScheduleDTO } from "../../../../models/ScheduleDTO"
import BotonCamaraCelular from "./camaraCelularBoton"

/*
	"Abrir Aula" (aula virtual, Fase 2): en la pantalla de Asistencias, donde el maestro ya ve sus clases de
	hoy, los horarios del plantel Online traen este botón. Entra a BigBlueButton como moderador en pestaña
	nueva, desde 15 min antes. El servidor decide quién puede (el maestro del horario, Servicios Académicos,
	Dirección Académica); si no es la hora o no le toca, el motivo sale aquí mismo.
*/
export const tieneAula = (horario: ScheduleDTO): boolean => Number(horario.campusId) === CAMPUS_ONLINE_ID

const BotonAbrirAula = ({horario, className} : {horario : ScheduleDTO, className? : string}) =>
{
	const [abriendo, setAbriendo] = useState<boolean>(false)
	const [aviso, setAviso] = useState<string | null>(null)

	const abrir = async () =>
	{
		setAviso(null)
		setAbriendo(true)
		try { await abrirAulaEnPestana(async () => (await aula.openRoom(horario.scheduleId)).data.url) }
		catch (e) { setAviso(mensajeDeAula(e)) }
		finally { setAbriendo(false) }
	}

	return <>
		<button type="button" className={className || "waAccionFila"} disabled={abriendo} onClick={(e) => { e.stopPropagation(); abrir() }}>
			Abrir Aula
		</button>
		<BotonCamaraCelular
			horario={horario}
			className={(className || "waAccionFila").replace(" principal", "") + ((className || "").includes("waTarjetaAccion") ? " secundaria" : "")}
		/>
		{aviso ? <span role="alert" style={{color : "var(--wa-oro, #A8730A)", fontSize : "14px", fontWeight : 600}}>{aviso}</span> : null}
	</>
}

export default BotonAbrirAula
